var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text',{staticClass:"primary--text",staticStyle:{"width":"100%"},attrs:{"category":"text-large"}},[_vm._v(" Welcome "),_c('span',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm.GET_currentUser.userName.split(" ")[0]))])])}
var staticRenderFns = []

export { render, staticRenderFns }